export default "__VITE_ASSET__lZMk_$HR__";